import React from 'react'
import Proptypes from 'prop-types'
import { TouchableOpacity, View } from 'react-native'
import Txt from '../Txt'
import CheckBox from '../CheckBox'
import { useStyles } from './useStyles'

const Option = ({
  item: option, multiselect, selected, nameProp,
  onSelectOption, getOptionLabel, isOptionSelected, theme
}) => {
  const styles = useStyles(theme)
  const currentSelected = !multiselect && selected ? option[nameProp] === selected[nameProp] : false
  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={() => onSelectOption(option)}
    >
      <View style={[styles.option, currentSelected && { backgroundColor: theme.GALLERY }]}>
        <Txt
          text={getOptionLabel ? getOptionLabel(option) : option[nameProp]}
        />
        {multiselect ? (
          <CheckBox
            onPress={() => onSelectOption(option)}
            checked={isOptionSelected(option)}
            testID='selectInputOptionsModalOptionCheckbox'
          />) : null}
      </View>
    </TouchableOpacity>
  )
}

Option.propTypes = {
  item: Proptypes.object,
  multiselect: Proptypes.bool,
  selected: Proptypes.object,
  nameProp: Proptypes.string,
  onSelectOption: Proptypes.func,
  getOptionLabel: Proptypes.func,
  isOptionSelected: Proptypes.func,
  theme: Proptypes.object
}

export default Option
